import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Projects from './views/ProjectWheel.vue'

/*
  Tutorial for Page Transitions: 
  https://www.youtube.com/watch?v=0aG2hhvS1sM
*/ 

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  // scrollBehavior() {
  //   return { x: 0, y: 0 };
  // },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects
    },
    {
      path: '/projects/port',
      name: 'port',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/projects/Port.vue')
    },
    {
      path: '/projects/explaining-carbon-capture',
      name: 'carbon-capture',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/projects/CarbonCapture.vue')
    },
    {
      path: '/projects/fhp-class-planer',
      name: 'class-planer',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/projects/Class-Planer.vue')
    },
    {
      path: '/projects/the-future-of-urban-transit',
      name: 'urban-transit',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/projects/UrbanTransit.vue')
    },
    {
      path: '/projects/robo-service-design',
      name: 'robo-service-design',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/projects/ServiceDesignAdvanced.vue')
    },
    {
      path: '/projects/workspaces',
      name: 'workspaces',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/projects/Workspaces.vue')
    },
    {
      path: '/projects/klassik-radio',
      name: 'klassik-radio',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/projects/KlassikRadio.vue')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  }
})
